import React, { useContext, useEffect } from 'react';
import { Components } from './styled';
import { ReactComponent as CloseIcon } from '../../assets/icons/icon-close.svg';
import { UIProviderContext } from '../../providers/UIProvider/context';
import useTableSearch from '../../hooks/useTableSearch';
import ProjectTableHeader from '../ProjectTableHeader';

const ProjectModal = ({
  bodyChildren,
  buttonChildren,
  tableSearchChildren,
  isModalOpen,
  onModalClose,
  modalTitle,
  titleSuffix,
  scrollType,
  modalWidth,
  disableCloseOnClickAway,
  cannotClose,
  tableSearchProps,
  setFilter,
  filter,
  searchLabel,
}: {
  bodyChildren: React.ReactNode;
  buttonChildren?: React.ReactNode;
  tableSearchChildren?: React.ReactNode;
  isModalOpen: boolean;
  onModalClose?: () => void;
  modalTitle: string;
  titleSuffix?: string;
  scrollType?: 'body' | 'paper';
  modalWidth?: number | 'auto';
  disableCloseOnClickAway?: boolean;
  cannotClose?: boolean;
  tableSearchProps?: ReturnType<typeof useTableSearch>;
  setFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  filter?: boolean;
  searchLabel?: string;
}) => {
  const { setIsModalOpen } = useContext(UIProviderContext);

  useEffect(() => {
    if (isModalOpen) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [isModalOpen]);

  const _onModalClose = () => {
    onModalClose?.();
  };

  return (
    <Components.Modal
      open={isModalOpen}
      onClose={(event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (!(disableCloseOnClickAway && reason === 'backdropClick')) {
          _onModalClose?.();
        }
      }}
      scroll={scrollType}
      modalWidth={modalWidth}
      disableEscapeKeyDown>
      <Components.ModalHeader noBottomLine={cannotClose}>
        <Components.TitleWrapper>
          <Components.ModalHeaderTitle>{modalTitle}</Components.ModalHeaderTitle>
          {titleSuffix && titleSuffix?.length > 0 && <Components.TitleSuffix>{titleSuffix}</Components.TitleSuffix>}
        </Components.TitleWrapper>
        <Components.ModalHeaderIconWrapper onClick={_onModalClose}>
          {cannotClose ? null : <CloseIcon />}
        </Components.ModalHeaderIconWrapper>
      </Components.ModalHeader>
      {tableSearchProps ? (
        <ProjectTableHeader searchLabel={searchLabel} {...tableSearchProps} setFilter={setFilter} filter={filter}>
          {tableSearchChildren}
        </ProjectTableHeader>
      ) : null}
      <Components.ModalContentContainer noBottomLine={cannotClose}>{bodyChildren}</Components.ModalContentContainer>
      {buttonChildren && <Components.ModalButtonsContainer>{buttonChildren}</Components.ModalButtonsContainer>}
    </Components.Modal>
  );
};

export default ProjectModal;
